import { useEffect, useState } from "react";

// Chart tooltips stick after a tap on touch screens; hide them as soon as the page scrolls.
export function useTooltipDismiss() {
  const [on, setOn] = useState(true);
  useEffect(() => {
    const off = () => setOn(false);
    window.addEventListener("scroll", off, { passive: true });
    return () => window.removeEventListener("scroll", off);
  }, []);
  return {
    active: on ? undefined : false,
    wake: { onMouseMove: () => setOn(true), onTouchStart: () => setOn(true) },
  };
}
